import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Features from "./components/Features";
import GenreGuide from "./components/GenreGuide";
import ColorStyle from "./components/ColorStyle";
import RecommendSection from "./components/RecommendSection";
import ReadingGuide from "./components/ReadingGuide";
import Faq from "./components/Faq";
import Tips from "./components/Tips";
import CtaBand from "./components/CtaBand";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <Features />
        <GenreGuide />
        <ColorStyle />
        <RecommendSection />
        <ReadingGuide />
        <Faq />
        <Tips />
        <CtaBand />
      </main>
      <Footer />
    </div>
  );
}